import { useUser } from "@clerk/react";
import { type FC, useEffect } from "react";

import { useSyncSubscriptionMutation } from "~/feature/subscription/subscriptionApi";
import { useAppUser } from "~/providers/UserProvider";

export const SyncSubscription: FC = () => {
  const { user } = useUser();
  const [syncSubscription, { isLoading }] = useSyncSubscriptionMutation();
  const { userSubscriptionPermissions, setSyncLoading } = useAppUser();

  useEffect(() => {
    if (!!userSubscriptionPermissions?.length && !!user) {
      syncSubscription({ featureSlugs: userSubscriptionPermissions });
    }
  }, [userSubscriptionPermissions, syncSubscription, user]);

  useEffect(() => {
    setSyncLoading(isLoading);
  }, [isLoading, setSyncLoading]);

  return null;
};
